// src/hooks/useTelegram.js
import { useEffect, useState } from 'react';

export const useTelegram = () => {
  const [telegram, setTelegram] = useState(null);
  const [user, setUser] = useState(null);
  const [initData, setInitData] = useState(null);
  const tgWebApp = window.Telegram?.WebApp;
  const hasTgWebAppDataParam = (() => {
    try {
      return !!new URLSearchParams(window.location.search).get('tgWebAppData');
    } catch (_) {
      return false;
    }
  })();

  // NOTE: telegram-web-app.js can exist in a normal browser; real Telegram runs with initData.
  const isTelegram = !!(tgWebApp?.initData && tgWebApp.initData.length > 0) || hasTgWebAppDataParam;

  const parseTgWebAppDataUser = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const raw = params.get('tgWebAppData');
      if (!raw) return null;

      const tgParams = new URLSearchParams(raw);
      const userRaw = tgParams.get('user');
      if (!userRaw) return null;

      return JSON.parse(decodeURIComponent(userRaw));
    } catch (_) {
      return null;
    }
  };

  useEffect(() => {
    const tg = window.Telegram?.WebApp;

    if (tg && isTelegram) {
      // Инициализируем Telegram Web App
      tg.ready();
      tg.expand();

      // Сохраняем объект WebApp
      setTelegram(tg);

      setInitData({
        initData: tg.initData,
        initDataUnsafe: tg.initDataUnsafe,
        platform: tg.platform,
        version: tg.version,
        colorScheme: tg.colorScheme,
      });

      // Извлекаем пользователя один раз
      const initUser = tg.initDataUnsafe?.user;
      if (initUser) {
        setUser(initUser);
      } else {
        const fallbackUser = parseTgWebAppDataUser();
        if (fallbackUser) setUser(fallbackUser);
      }
    } else {
      const fallbackUser = parseTgWebAppDataUser();
      if (fallbackUser) {
        setUser(fallbackUser);
      } else {
        // outside Telegram: miniapp should be gated in UI
      }
    }
  }, []);

  return {
    tg: telegram,
    user,
    isReady: !!telegram,
    initData,
    isTelegram,
  };
};
